export const IMAGE_DETECTION_REGEXP = /(<img[^>]+>(?:<\/img>)?)/g;
